__webpack_require__.p = "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/i18n/ecom/alliance/seller/connection-submodule/";